import PatientAdminHome from "./home";

export default PatientAdminHome;
